export const brand = {
  logo: "https://customer-assets.emergentagent.com/job_8e5287b3-719b-4c0b-b775-717eb0e78544/artifacts/0p64vl1j_logohg.png",
  heroBanner: "https://customer-assets.emergentagent.com/job_8e5287b3-719b-4c0b-b775-717eb0e78544/artifacts/vrbbobrc_ChatGPT%20Image%20Jun%2028%2C%202026%2C%2007_52_08%20PM.png",
  instructorPortrait: "https://customer-assets-lqy194kg.emergentagent.net/job_8e5287b3-719b-4c0b-b775-717eb0e78544/artifacts/8e5cg895_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2009_15_38%20AM.png"
};

export const mockData = {
  hero: {
    titleTe: "భగవద్గీత హీలింగ్",
    title: "Bhagavadgita Healing",
    tagline: "A frequency-based healing method — no outer tools needed. Only your mudra, your breath, and your own energy centers.",
    startDate: "July 13, 2026",
    startISO: "2026-07-13T06:00:00",
    batches: [
      { time: "6:00 AM", label: "Morning Batch", value: "morning" },
      { time: "11:00 AM", label: "Day Batch", value: "day" },
      { time: "6:00 PM", label: "Evening Batch", value: "evening" }
    ]
  },
  whatIs: {
    title: "What is Bhagavadgita Healing?",
    lead: "Bhagavadgita Healing is a pure, frequency-based healing method. It needs nothing from outside — no objects, no props, no rituals.",
    points: [
      { title: "Sacred Mudras", description: "Simple hand gestures that direct and awaken the flow of divine energy within you." },
      { title: "Conscious Breath", description: "Guided breath patterns that calm the mind, purify the body, and raise your inner frequency." },
      { title: "Energy Centers", description: "Activation of your own chakras and energy centers to heal from the inside out." }
    ],
    closing: "Everything you need is already within you. Bhagavadgita Healing simply awakens it."
  },
  outcomes: {
    title: "18 Healing Outcomes",
    subtitle: "Solutions across three dimensions of life",
    groups: [
      {
        name: "Personal",
        description: "Success and harmony in your outer life.",
        items: [
          "Career & professional growth",
          "Financial abundance",
          "Harmony in relationships",
          "Success in your goals",
          "Peace within the family",
          "Confidence & leadership"
        ]
      },
      {
        name: "Internal",
        description: "Peace and strength within your mind.",
        items: [
          "Relief from stress & anxiety",
          "Emotional balance",
          "Freedom from fear",
          "Deep, restful sleep",
          "Mental clarity & focus",
          "Lasting inner peace"
        ]
      },
      {
        name: "External",
        description: "Vitality and healing in your body & energy.",
        items: [
          "Physical health & vitality",
          "Clearing of energy blockages",
          "Support for chronic issues",
          "Chakra balancing",
          "Stronger immunity & healing",
          "Protection from negativity"
        ]
      }
    ]
  },
  program: {
    title: "Energy Analysis Programme",
    subtitle: "Join now at your convenient time",
    note: "Discover the hidden energy patterns within you. Kriyayogi Bhargousarma guides you to analyse and balance your inner energy — begin today, at whatever time suits you best."
  },
  instructor: {
    name: "Kriyayogi Bhargousarma",
    role: "Lifestyle Manifestation Coach & Healer",
    intro: "Kriyayogi Bhargousarma has dedicated his entire life to promoting Kriyayoga and awakening people to their true inner power.",
    credentials: [
      { value: "60+", label: "Kriyayoga practices developed" },
      { value: "9+", label: "Manifestation methods created" },
      { value: "1", label: "Founder of Bhagavadgita Healing" }
    ],
    promises: [
      "He can guide you to achieve success",
      "He can help you become wealthy",
      "He can help you become healthy"
    ]
  },
  gallery: {
    title: "Watch & Learn",
    subtitle: "A glimpse into the transformational journey",
    videos: [
      {
        title: "Bhagavad Gita Healing Programme",
        videoUrl: "https://www.youtube.com/embed/eDqp8-6dKGI"
      },
      {
        title: "Bhagavad Gita Healing - Bhava Roga Freedom",
        videoUrl: "https://www.youtube.com/embed/5PD6EcxsEZk"
      }
    ]
  },
  testimonials: {
    title: "Voices of Transformation",
    subtitle: "What our sadhakas say",
    items: [
      {
        name: "Srinivas",
        role: "March Diksha",
        quote: "Kundalini Jaagruthi intha saralamga bhodinchi maa jeevitha gamyaaniki maargaanni teliya jesaru. Dhanyavaadhaalu Guruvu garu."
      },
      {
        name: "T V Murali Krishna",
        role: "Pranava Sadhana",
        quote: "నేను కొద్దిరోజులుగా ప్రణవసాధన ప్రాక్టీస్ చేస్తున్నాను.. చాలా అద్భుతంగా వున్నది. ఏ ప్రాక్టీస్ చేసినా రాని శక్తి కేవలం ప్రణవసాధన వలన వచ్చింది."
      },
      {
        name: "Nalabolu Srinivasarao",
        role: "Sadhaka",
        quote: "గురూజీ ప్రాణాయామము మరియు కపాలభాతి, సహజ ధ్యానం వరకు అన్నీ వివరముగా తెలియజేయగలరు. ఈ ధ్యానం వల్లన మా జీవితములో కచ్చితంగా మార్పు వస్తుంది."
      },
      {
        name: "S Venkata Sivaiah",
        role: "6-Day Kriya Yoga",
        quote: "Excellent results, and guidance that is easy to understand. Must join!"
      },
      {
        name: "Dhanalaxmi Sriramoju",
        role: "Law of Attraction & Kriya",
        quote: "Namaskaram Gurujii, your classes are very useful to us. I joined the Law of Attraction batch — the guidance and Kriyayoga sessions are truly wonderful."
      }
    ]
  },
  contact: {
    title: "Join the Programme",
    subtitle: "Reserve your seat for the next batch",
    description: "Take the first step towards transformation. Fill in your details below and our team will guide you with the session details.",
    phone: ["7416852211", "7416879900", "6301066498"],
    email: "spirituallifeskills18@gmail.com",
    razorpay: "https://razorpay.me/@chidhgurugita",
    gitaChallenge: "https://forms.gle/7zbuJrVUD24so1wg8"
  }
};
